import { StatusIcon } from './StatusIcon'

/**
 * Whether an idea is out on a channel: an empty ring to tick, or the same
 * check a published idea wears.
 */
export function PostedMark({ posted, size = 16 }: { posted: boolean; size?: number }) {
  if (posted) return <StatusIcon status="published" size={size} />
  return (
    <svg className="posted-ring" width={size} height={size} viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <circle cx="8" cy="8" r="6.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}
